import React from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import MenuBar from "../../components/MenuBar";
import HeaderBar from "../../components/HeaderBar";
import { useAuth } from "../../context/AuthContext";
import CreditReceivePaymentContent from "./CreditReceivePaymentContent";
import { useCreditBranchFilter } from "./useCreditBranchFilter";
import CreditBranchSelector from "./CreditBranchSelector";

export default function CreditReceivePayment() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const preCustomer = searchParams.get("customerId") || "";
  const { user: storedUser } = useAuth();
  const { branch, setBranch, visibleBranches } = useCreditBranchFilter(storedUser);

  return (
    <div className="min-h-screen bg-slate-100/90">
      <Toaster position="top-right" />
      <MenuBar />
      <HeaderBar />
      <main className="mx-auto max-w-3xl px-3 pb-24 pt-4 sm:px-4">
        <Link to="/credit-due" className="text-sm font-semibold text-indigo-600 hover:underline">
          ← Credit / Due
        </Link>
        <h1 className="mt-2 text-lg font-bold text-slate-900">Receive payment</h1>
        <div className="mt-3 rounded-lg border border-slate-200 bg-white px-3 py-2">
          <CreditBranchSelector value={branch} onChange={setBranch} options={visibleBranches} />
        </div>
        <div className="mt-4 rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
          <CreditReceivePaymentContent
            key={`${preCustomer || "page"}-${branch}`}
            branch={branch}
            initialCustomerId={preCustomer}
            onSuccess={() => navigate("/credit-due")}
          />
        </div>
      </main>
    </div>
  );
}
